import React from 'react';
import { PageLayout } from '@/shared/components/PageLayout';
import { Box } from '@material-ui/core';
import imgPath from './images/management.png';
export const Management = () => (React.createElement(PageLayout, null,
    React.createElement(Box, { textAlign: "center", mt: "8rem" },
        React.createElement("img", { src: imgPath, width: "1000", alt: "management" }))));
